import { Link } from "react-router-dom";
import type { Program, ProgramAccent } from "../data/programs";

const accentClasses: Record<ProgramAccent, { chip: string; orb: string; text: string }> = {
  leaf: {
    chip: "bg-accent-leaf text-brand-ink",
    orb: "bg-accent-leaf/70",
    text: "text-accent-leaf-deep",
  },
  cobalt: {
    chip: "bg-accent-cobalt text-white",
    orb: "bg-accent-cobalt/70",
    text: "text-accent-cobalt-deep",
  },
  sun: {
    chip: "bg-accent-sun text-brand-ink",
    orb: "bg-accent-sun/70",
    text: "text-accent-sun-deep",
  },
  violet: {
    chip: "bg-accent-violet text-white",
    orb: "bg-accent-violet/70",
    text: "text-accent-violet-deep",
  },
};

interface ProgramCardProps {
  program: Program;
}

export function ProgramCard({ program }: ProgramCardProps) {
  const c = accentClasses[program.accent];
  return (
    <article className="relative overflow-hidden rounded-3xl border border-gray-300 bg-white p-7 transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg">
      <div
        className={`hex absolute -right-12 -top-12 h-44 w-44 ${c.orb}`}
        aria-hidden="true"
      />
      <div className="relative">
        <span
          className={`inline-block rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-widest ${c.chip}`}
        >
          {program.short} · {program.ages}
        </span>
        <h3 className="mt-4 font-display text-2xl font-semibold leading-tight">
          {program.name}
        </h3>
        <p className="mt-3 text-sm text-gray-700">{program.long}</p>
        <p className="mt-4 text-xs uppercase tracking-widest text-gray-700">
          {program.when}
        </p>
        <Link
          to={`/programas/${program.slug}`}
          className={`mt-5 inline-flex items-center gap-1 text-sm font-semibold ${c.text} hover:underline`}
        >
          {program.ctaLabel} →
        </Link>
      </div>
    </article>
  );
}
